import React from 'react';
import styled, { css } from 'styled-components';
import { connect } from 'react-redux';
import { withNamespaces } from 'react-i18next';
import { followPressroom, unfollowPressroom } from 'modules/following/actions';
import { saveFollowData } from 'modules/user/actions';
import { showLogin } from 'modules/user/actions';
import { isAuthenticated } from 'modules/user/reducers';
import { isFollowingNewsroom } from 'modules/following/reducers';
import { getCompanyNameById } from 'modules/global/reducers';
import { SECONDARY_10, SECONDARY_100 } from 'theme/tokens/colors';

const Button = styled.button`
  background: #fff;
  border-radius: 2px;
  border: #ced9e2 1px solid;
  color: #00233d;
  font-size: 1.125rem;
  font-weight: 600;
  line-height: 1.5rem;
  margin-left: 0;
  padding: 0.75rem 1.5rem;
  text-transform: capitalize;

  &:hover {
    border-color: ${SECONDARY_100};
    background: ${SECONDARY_100};
    color: #fff;
  }

  &:focus {
    border-color: ${SECONDARY_100};
    box-shadow: 0 0 0 3px ${SECONDARY_10};
    outline: none;
  }

  ${props =>
    props.active &&
    css`
      border-color: ${SECONDARY_100};
      background: ${SECONDARY_100};
      color: #fff;
    `}
`;

const Follow = ({ id, active, toggle, companyName, t }) => {
  return (
    <Button
      active={active}
      className="track-element"
      value={id}
      onClick={toggle}
      data-event-category="Follow button"
      data-event-action={active ? 'Unfollow' : 'Follow'}
      data-event-label={companyName}
    >
      {active
        ? t('common_follow-newsroom-active')
        : t('common_follow-newsroom')}
    </Button>
  );
};

export default connect(
  (state, ownProps) => ({
    active: isFollowingNewsroom(state, ownProps.id),
    _isAuthenticated: isAuthenticated(state),
    companyName: getCompanyNameById(state, ownProps.id),
  }),
  (dispatch, ownProps) => ({
    _follow: (id, toggle) =>
      dispatch(toggle ? unfollowPressroom(id) : followPressroom(id)),
    _login: () => dispatch(showLogin()),
    _saveFollowData: id => dispatch(saveFollowData(id)),
  }),
  (
    { _isAuthenticated, ...stateProps },
    { _follow, _login, _saveFollowData, ...dispatchProps },
    ownProps,
  ) => ({
    ...stateProps,
    ...dispatchProps,
    ...ownProps,
    toggle: e => {
      const id = e.currentTarget.value;
      if (!_isAuthenticated) {
        _login();
        _saveFollowData(id);
      } else {
        _follow(id, stateProps.active);
      }
    },
  }),
)(withNamespaces()(Follow));
